import { ProductCatalogueResponse } from 'pco-product-service-internal-consumer';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProductStateType } from 'types';

export const initialProductState: ProductStateType = {
  products: [],
  error: false,
  isLoading: false,
};

const productSlice = createSlice({
  name: 'PRODUCT',
  initialState: initialProductState,
  reducers: {
    setEligibleProducts: (state, action: PayloadAction<ProductCatalogueResponse[]>) => {
      state.products = action.payload;
    },
  },
});

export const { setEligibleProducts } = productSlice.actions;
export default productSlice.reducer;
